import {ModuleFc} from '@/project'
import {removeItem, updateAll} from '@/store/utils'
import {Bank, BankState, CreateBankPayload} from './types'

export {BankState}

const module: ModuleFc<BankState> = (ctx) => ({
  namespaced: true,
  state: {
    selectedBankCode: '',
    banks: [],
    owner: '',
  },
  actions: {
    /**
     * Get Bank list by biz id
     * @param commit
     * @param rootState
     * @param bizId
     */
    async getBanks({commit, rootState}, bizId) {
      const result = await ctx.$axios({
        url: '/banks',
        method: 'get',
        data: {
          get bizId() {
            return bizId || rootState.biz.id
          },
        },
      })
      commit('replace', result.data.results)
    },
    /**
     * Get bank account owner by bankCode & bank account number
     * @param commit
     * @param payload
     */
    async getOwner({commit}, payload: {
      bankCode: string,
      number: string,
    }) {
      const result = await ctx.$axios({
        url: '/owner-name',
        method: 'post',
        data: {
          get number() {
            return payload.number
          },
          get bankCode() {
            return payload.bankCode
          },
        },
      })
      commit('updateOwner', result.data.ownerName)
    },
    /**
     * Create a new Bank item and save in Bank list
     * @param _
     * @param payload
     */
    async createBank(_, payload: CreateBankPayload) {
      await ctx.$axios({
        url: '/banks',
        method: 'post',
        data: payload,
      })
    },
    /**
     * Remove a Bank item from Bank list
     * @param commit
     * @param rootState
     * @param payload
     */
    async removeBank({commit, rootState}, payload: { id?: string, bizId?: string } = {}) {
      const {id} = payload
      await ctx.$axios({
        url: '/banks/$id',
        method: 'delete',
        data: {
          get bizId() {
            return payload.bizId || rootState.biz.id
          },
          id,
        },
      })
      commit('remove', id)
    },
  },
  mutations: {
    /**
     * Remove all banks and add new Bank list
     * @param state
     * @param payload
     */
    replace(state, payload: Bank[]) {
      state.banks = payload
    },
    /**
     * update old banks by bank list
     * @param state
     * @param payload
     */
    update(state, payload: Bank[]) {
      updateAll(state.banks, payload)
    },
    updateOwner(state, payload: string) {
      state.owner = payload
    },
    updateBankCode(state, payload: string) {
      state.selectedBankCode = payload
    },
    remove(state, id: string) {
      removeItem(state.banks, {id})
    },
    addBank(state, payload) {
      state.banks = [...state.banks, payload]
    },
    clear(state) {
      state.banks = []
    },
    clearBankCode(state) {
      state.selectedBankCode = ''
    }
  },
})

export default module
